import classNames from 'classnames';
import { FC } from 'react';
import styles from './Tag.module.css';
import { TagProps, TagTypes } from './Tag.types';

const Tag: FC<TagProps> = ({ type = TagTypes.Holiday, label, link, fullWidth = false, className, title }) => {
  if (link !== undefined) {
    return (
      <button
        className={classNames(styles.tag, styles[type], styles.button, {
          [styles.fullWidth]: fullWidth,
          [className!]: className !== undefined,
        })}
        onClick={link?.onClick}
        type="button"
        title={title}
      >
        {`${label} `}
        <span className={styles.linkText}>{`${link?.text}`}</span>
      </button>
    );
  }
  return (
    <div
      className={classNames(styles.tag, styles[type], {
        [styles.fullWidth]: fullWidth,
        [className!]: className !== undefined,
      })}
      title={title}
    >
      {label}
    </div>
  );
};
export default Tag;
